import { API_BASE_URL } from "../urls.api";

export const CUSTOMER_DEVICES_URL = `${API_BASE_URL}/customer-devices`;

export const retireDeviceUrl = (roomId: string) => `${CUSTOMER_DEVICES_URL}/rooms/${roomId}/retire`;

export const reassignDeviceUrl = (roomId: string) =>
  `${CUSTOMER_DEVICES_URL}/rooms/${roomId}/reassign`;
